import useConfigureAxios from "@FRAMEWORK/utils/useConfigureAxios";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import {Response} from "@QUERIES/types";
import {UseQueryOptions, useQuery} from "@tanstack/react-query";

interface Wish {
	evCd: string;
	goodsCd: string;
	goodsNm: string;
	goodsTp: string;
	imageThum: string;
	inArriveDt: string;
	inArriveTm: string;
	itemCategoryCode: "P" | "D" | "IC02" | "IC04" /* IC02호텔 IC04티켓 P해외PKG D국내';*/;
	link: string;
	outAirCd: string;
	outAirCompany: string;
	outStartDt: string;
	outStartTm: string;
	productWishId: string;
	soldoutYn: "Y" | "N";
	startDt: string;
	updDt: string;
}

interface ResponseWish {
	errorCode: string;
	errorMsg: string;
	wishProductsResultList: Wish[];
}

const key = "useWishlist";
/** ```
 * 위시리스트 조회
 *  `/customer/wishList?webCustNo={webCustNo}`
 * parameter
 * ```*/
const getPath = (webCustNo: string): string =>
	`${publicRuntimeConfig.ENV_ESSENTIAL_API_BASEPATH}/api/customer/wishList?webCustNo=${webCustNo}`;

/** ```
 * 위시리스트 조회
 *   `/customer/wishList?webCustNo={webCustNo}`
 * parameter
 * ```*/
const useWishlist = (webCustNo: string, options?: Partial<UseQueryOptions<Response<ResponseWish>, Error>>) =>
	useQuery({
		queryKey: [key, getPath(webCustNo)],
		queryFn: () => useConfigureAxios({url: getPath(webCustNo)}).then(r => r.data),
		gcTime: Infinity,
		staleTime: Infinity,
		...options,
	});

export default useWishlist;
export {getPath};
export type {Wish, ResponseWish};
